export interface PumpMoto {
  id: number;
  placeID: number;
  placeName: string;
  name: string;
  EngineID: number;
  EngineName: string;
  CompanyID: number;
  CompanyName: string;
  isFavorite: boolean;
  remoteControl: boolean;
  energyMonitoring: boolean;
  inUseSet: boolean;
  Status: number;
}

export const STATUS = {
  ACTIVE: 1,
  INACTIVE: 0
}


const en: any = {
  id: 1,
  placeID: 1,
  placeName: 1,
  name: 2,
  EngineID: 1,
  EngineName: 1,
  CompanyID: 1,
  CompanyName: 1,
  isFavorite: true,
  remoteControl: true,
  energyMonitoring: true,
  inUseSet: true,
  Status: 1,
}
export { en };
